import { label } from "./Attributes";

export default function Preview() {
    return (
        <span className="ms-3">
            <span className="me-2">{label}</span>
        </span>
    );
}
